// extracted by mini-css-extract-plugin
module.exports = {"role-btn":"RoleForm__role-btn___B9Ujt","active":"RoleForm__active___3QuR8","reg-button":"RoleForm__reg-button___3WRSJ","disabled":"RoleForm__disabled___21G1W"};